import {
  type ColumnConfigurations,
  type ColumnRenderer,
  type TableColumnType,
  COLUMN_DEFINITIONS,
} from './definitions'

export type TableColumn = {
  label: string
  render: ColumnRenderer
  sorting?: string
}

export const createTableProperties = (
  columns: TableColumnType[],
  configurations?: ColumnConfigurations
): TableColumn[] =>
  columns
    .filter((col) => col in COLUMN_DEFINITIONS)
    .map((col) => {
      const def = COLUMN_DEFINITIONS[col]
      return {
        label: def.label(),
        render: def.render(configurations),
      }
    })
